import api from '../baseAPIs/core';
import { Settings } from '@extTypes/settings/settings';
import { VersionInfo } from '@extTypes/versioning';

export const listSettingsVersions = async (storeUrl: string): Promise<VersionInfo[]> => {
    const response = await api.get<VersionInfo[]>(`/Store/${storeUrl}/Settings`);
    return response.data;
};

export const getSettingsFromVersion = async (key: string, versionId: string): Promise<Settings.Settings> => {
    const response = await api.get<Settings.Settings>(`/Store/Settings/Version`, {
        params: { key, versionId }
    });
    return response.data;
};
